import { camelizeKeys } from '../lib/functions';

export default {
  state: [],
  getters: {
    followees: state => state,
    followeeById: state => memberId => state.find(followee => followee.memberId === memberId),
  },
  mutations: {
    addFollowee(state, payload) {
      state.push(payload);
    },
    addFollowees(state, payload) {
      state.push(...payload);
    },
    clearFollowees(state) {
      state.length = 0;
    },
  },
  actions: {
    addFollowee(context, payload) {
      context.commit('addFollowee', payload);
    },
    addFollowees(context, payload) {
      context.commit('addFollowees', payload);
    },
    clearFollowees(context) {
      context.commit('clearFollowees');
    },
    async loadFollowees(context) {
      const response = await this.$container.dao.getFollowees(context.getters.memberId);
      await context.commit('clearFollowees');
      context.commit('addFollowees', response.data.followees.map(camelizeKeys));
    },
  },
};
